<template>
  <v-list-item lines="two" class="px-3">
    <template v-if="!emphasysOnTitle">
      <!-- Slot além da prop, como no PageHeader: há rótulo que leva um botão ao
           lado, caso do relacionamento com Kanban na ficha da instância. -->
      <v-list-item-subtitle  class="mr-auto">
        <slot name="title">{{ title }}</slot>
      </v-list-item-subtitle>
      <v-list-item-title style="white-space: normal" class="mr-auto">
        <slot></slot>
      </v-list-item-title>
    </template>
    <template v-else>
      <v-list-item-title class="mr-auto">
        {{ title }}
      </v-list-item-title >
      <v-list-item-subtitle style="white-space: normal;" class="mr-auto">
        <slot></slot>
      </v-list-item-subtitle>
    </template>
  </v-list-item>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

@Component
class ViewInfo extends Vue {
  @Prop({type: String}) readonly title!: string
  @Prop({type: Boolean, default: false}) readonly emphasysOnTitle!: boolean


  name = 'ontos-view-info'
}

export default toNative(ViewInfo)
</script>

<style scoped>
/* Alinhado pelo TOPO, e não centralizado.

   O v-list-item traz `align-items: center` e um mínimo de 64px no modo two-line, e o
   conteúdo ainda vem com `align-self: center`. Num campo curto o conteúdo é menor que
   esse mínimo e acaba centralizado nele, então o rótulo desce alguns pixels — o
   bastante para desalinhar dos rótulos vizinhos numa fileira de campos, onde o lado
   com uma imagem começa no topo e o lado com uma palavra não.

   O v-list-item é a RAIZ deste componente, então recebe o atributo de escopo daqui.
   O .v-list-item__content não: no Vuetify 4 ele é elemento interno do v-list-item —
   no 2 era a raiz de um componente desenhado aqui —, e por isso vai por :deep(). */
.v-list-item {
  align-items: flex-start;
  /* O mínimo de 60/64px é medida de LINHA DE LISTA, para o dedo ter onde tocar. Aqui
     não se clica em nada: num campo curto ele vira só sobra morta embaixo do valor. */
  min-height: 0;
}

/* O recuo vertical de 12px também é do v-list-item, e é dado SÓ na vertical — some
   somado ao gutter da grade, ele afastava a linha de baixo quase o dobro do que
   afasta o campo ao lado. Quem espaça esta grade é o gutter do v-col, uma vez só. */
.v-list-item :deep(.v-list-item__content) {
  align-self: flex-start;
  padding: 0;
}
</style>